export enum CustomProviderIdentityFlag {
  OKTO_WALLET = "isOktoWallet",
}
